import { connect } from "react-redux";
import PaymentDetails from "./paymentDetails";
import { bindActionCreators } from "redux";
import { vendorPaymentDetails} from "services/redux/sales/vendorPortal/action";


import {
  fetchZones,
} from "services/redux/sales/preSaleListing/action";

const mapStateToProps = (state) => ({
  dataList: state.vendorPortalReducer.payment_detail,
  poDetail: state.vendorPortalReducer.poDetail,
 
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchZones,
     
      vendorPaymentDetails,
      
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PaymentDetails);
